import { useCallback } from 'react';
import Point from '../../Common/Utils/Math/Point';
import { useDispatch, useSelector } from 'react-redux';
import { EditZoom } from '../../UIData/_actions/DesignLabStoreActions';
import WebsiteStore from '../../WebsiteStore';
import useStageDimensions from './useStageDimensions';
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';

export default function useZoom() {
    const dispatch = useAppDispatch();
    const { stageWidth, stageHeight } = useStageDimensions();

    const zoomScale = useAppSelector(state => state.get('UIData').get('designLab').get('zoomScale'));
    const zoomOffsetX = useAppSelector(state => state.get('UIData').get('designLab').get('zoomOffsetX'));
    const zoomOffsetY = useAppSelector(state => state.get('UIData').get('designLab').get('zoomOffsetY'));

    return useCallback((zoom: number, position: Point) =>
        dispatch(EditZoom(zoom, position, {x: stageWidth, y: stageHeight})), 
        [zoomScale, zoomOffsetX, zoomOffsetY, stageWidth, stageHeight]
    );
}